import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "dark",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "dark" ? "light" : "dark";
    },
  },
});

export const { setMode } = authSlice.actions;
export default authSlice.reducer;